import React from 'react'
import Submittedcard from '../../Components/Card/Piechatcard/Piechat-card'
import './Piechart.css'

const Piechart = () => {
  return (
    <div className='performance-container'>
      <Submittedcard />
    </div>
  )
}

export default Piechart